<template>
    <b-col cols="12" lg="2" :class="{'neu-card': true, 'neu-card-clinic-history': true, 'section-completed': completed, 'block-selected': blockSelected, 'completed-block-selected': completedBlockSelected}" @click="action()">
        <div class="my-auto px-2 px-sm-4">
            <p :class="{ 'd-inline-block': $uiHelpers.isMobile, gray: completed}" :style="{color: titleColor}" class="neu-card-clinic-title">{{title}} <span v-if="completed" :style="`display: block;font-size: 0.8rem;color: ${titleColor};font-weight: normal;`">({{$t('completedQuiz')}})</span></p>
        </div>
    </b-col>
</template>

<script>
import { BLACK_COLOUR } from '@/constants/colours'

export default {
    computed: {
        iconSize () {
            return this.$uiHelpers.isMobile ? '30' : '40'
        },
        completedBlockSelected () {
            return this.completed && this.id === this.blockIdSelected
        },
        blockSelected () {
            return !this.completed && this.id === this.blockIdSelected
        },
        blockOpacity () {
          return this.blockIdSelected && this.id !== this.blockIdSelected
        },
        titleColor () {
            return this.completed ? BLACK_COLOUR : ''
        }
    },
    components: {
    },
    props: {
        id: String,
        title: {
            type: String,
            required: true
        },
        action: {
            type: Function,
            required: true
        },
        completed: Boolean,
        blockIdSelected: String
    },
    data () {
        return {
        }
    },
    created () {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@import 'static-appopensalud/css/scss/bootstrap-variables.scss';

  .neu-card {
    overflow: hidden;
    box-shadow: $custom-shadow;
    padding: $padding-bg;
    border-radius: $border-radius;
    border: $border;
    background-color: $body-bg;

    @include mobile {
      padding: $padding-md;
    }
  }

  .neu-card-title {
    .btn {
      margin-top: 0px !important;
    }
  }
.neu-card-clinic-history {
    min-height: 155px;
    @include mobile {
        min-height: 80px;
    }
    @include tablets {
        min-height: 130px;
    }
    @include desktop {
    padding: 2rem;
    margin-bottom: 2rem;
  }

  @include desktop-sm {
    padding: .5rem;
  }

  @include media(mobile, tablets) {
    padding: 1rem;
    margin: {
      bottom: 2rem;
    }
  }
  
  background-color: $white;
  transition: all .5s ease;

  &:hover {
    border: 1px solid $blue;
  }
  text-align: center;

  margin: {
    top: auto;
    bottom: auto;
  }

  p {
    color: $blue;
    font-weight: bold;
  }

  div {
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;

    @include desktop {
      padding: 2.5rem;
    }
    
    @include desktop-sm {
      padding: 0.5rem;
    }
  }
}

.neu-card-clinic-title {
    @include tablets {
        max-height: 45px;
        height: auto;
    }
    vertical-align: middle;
}

p {
    @include mobile {
        margin: {
            top: 0 !important;
            bottom: 0 !important;
        }
    }
}
.section-completed{
    background-color: $green;
}
.block-selected{
    background-color: $white;
}
.completed-block-selected{
    border: 2px solid $white !important;
}
.block-opacity{
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/views/clinicHistory/quiz/ClinicHistoryQuizBlock.vue